import { message } from "antd";
import { StartTestingService } from "api/newTesting";
import { getGroupStartTestingService } from "api/testing";
import { startPretestService } from "api/pretest";
import { clearLSTesting, localDataExam } from "util/setLocalStorageTesting";

/////////////////////// set previous data / params  ////////////////////////////////////////////
export const typeOfParams = (queryString) => {
  if (queryString?.groupId || queryString?.typeExam === "groupExam") {
    return "groupExam";
  } else if (queryString?.typeExam === "pretestExam") {
    return "pretestExam";
  } else {
    return "generalExam";
  }
};

export function setParams(testingId, queryString) {
  switch (typeOfParams(queryString)) {
    case "groupExam": {
      const groupId = queryString?.groupId || null;
      if (testingId.includes("groupId")) {
        testingId = testingId.split("?groupId")[0];
      }
      return {
        keyLocal: groupId,
        testingId: testingId,
        groupId,
        typeExam: "groupExam",
      };
    }
    case "pretestExam":
      const pretestId = testingId || null;
      return { keyLocal: pretestId, testingId, typeExam: "pretestExam" };
    default:
      return {
        keyLocal: "generalExam",
        testingId: testingId,
        typeExam: "generalExam",
        bundleId: queryString.bid,
      };
  }
}

export function fetchStarting(params) {
  return new initailTesting(params);
}

function initailTesting(props) {
  localStorage.setItem("startTesting", "on");
  switch (props?.typeExam) {
    case "randomExam":
      return randomTesting(props);
    case "groupExam":
      return groupTesting(props);
    case "pretestExam":
      return pretestTesting(props);
    case "generalExam":
      return generalTesting(props);
    default:
      return generalTesting(props);
  }
}

async function randomTesting(props) {
  const {
    amoungQuestions,
    gradeId,
    lessonId,
    subjectId,
    examTypeId,
    publisherId,
  } = props?.state;
  console.log("propsState", props);
  return await StartTestingService({
    amoungQuestions: amoungQuestions,
    gradeId: gradeId,
    lessonId: lessonId,
    subjectId: subjectId,
    examTypeId: examTypeId,
    publisherId: publisherId,
  });
}

async function groupTesting(props) {
  const { testingId, groupId } = props;
  if (testingId.includes("groupId")) {
    return await getGroupStartTestingService(
      testingId.split("?groupId")[0],
      groupId
    );
  } else {
    return await getGroupStartTestingService(testingId, groupId);
  }
}

async function pretestTesting(props) {
  if (props?.testingId) {
    return await startPretestService(props.testingId);
  }
}

async function generalTesting(props) {
  if (!props) {
    window.location.href = "/";
  } else {
    const { testingId } = props;
    return await StartTestingService({ examId: testingId });
  }
}

/////////////////////// Disconnect Case ////////////////////////////////////////////
const clearDisconnect = () => {
  localStorage.removeItem("startTesting");
  localStorage.removeItem("waitForFinish");
  localStorage.removeItem("randomExam");
  clearLSTesting();
};

export const getTestFromDisconnect = (props) => {
  const typeexam = localDataExam.get(
    localStorage.getItem("waitForFinish")
  )?.typeExam;
  const examId = localDataExam.get(localStorage.getItem("waitForFinish"))?.data
    ?.id;
  if (typeexam) {
    if (typeexam === "pretestExam") {
      return props.history.push({
        pathname: `/testing/${localStorage.getItem("waitForFinish")}`,
        state: {
          type: "pretest",
          data: localDataExam.get(localStorage.getItem("waitForFinish"))?.data,
        },
        search: "typeExam=pretestExam",
      });
    } else if (typeexam === "groupExam") {
      const groupId = localStorage.getItem("waitForFinish");
      return props.history.push({
        pathname: `/testing/${examId}`,
        state: {
          data: localDataExam.get(localStorage.getItem("waitForFinish"))?.data,
        },
        search: `groupId=${groupId}&typeExam=groupExam`,
      });
    } else if (typeexam === "generalExam") {
      return props.history.push({
        pathname: `/testing/${examId}`,
        state: {
          data: localDataExam.get(localStorage.getItem("waitForFinish"))?.data,
        },
      });
    } else if (typeexam === "randomExam") {
      clearDisconnect();
      props.history.push("/");
    } else {
      clearDisconnect();
      props.history.push("/");
    }
  }
};

/////////////////////// Error case for StartTesting ////////////////////////////////////////////
const checkNotFoundTesting = (response) => response?.list?.length === 0;
const checkAmountDeviceExceed = (response) =>
  response?.error.errorTesting?.statusCode === "amount_device_exceeded";
const checkAccessTesting = (response) => response?.error?.code === 403;

export const errorStarting = async (
  response,
  previousData,
  props,
  setOpenChangeDV,
  setDataFromError
) => {
  if (response?.list?.length === 0) {
    localStorage.removeItem("startTesting");
    message.error("ไม่พบข้อสอบที่ต้องการ");
    return props.history.goBack();
  }
  if (checkAmountDeviceExceed(response)) {
    localStorage.removeItem("startTesting");
    setDataFromError(response?.error.errorTesting);
    return setOpenChangeDV(true);
  }
  if (checkAccessTesting(response)) {
    localStorage.removeItem("startTesting");
    return props.history.push("/pretest");
  }
  if (checkNotFoundTesting(response)) {
    localStorage.removeItem("startTesting");
    message.error("ยังไม่มีชุดข้อสอบ");
  }
  if (
    response?.error?.code === 422 &&
    props.location.search.search("pretest") === -1
  ) {
    message.error(response?.error?.message, [5]);
  } else {
    localStorage.removeItem("startTesting");
    return props.history.push("/");
  }
  localStorage.removeItem("startTesting");
  // message.error(response?.error?.message, [5])
  return props.history.goBack();
};

export const errorStartingTesting = async (
  response,
  previousData,
  props,
  setOpenChangeDV,
  setDataFromError
) => {
  if (response?.list?.length === 0) {
    localStorage.removeItem("startTesting");
    message.error("ไม่พบข้อสอบที่ต้องการ");
    return props.history.goBack();
  }
  if (checkAmountDeviceExceed(response)) {
    localStorage.removeItem("startTesting");
    setDataFromError(response?.error.errorTesting);
    return setOpenChangeDV(true);
  }
  if (checkAccessTesting(response)) {
    localStorage.removeItem("startTesting");
    return props.history.push("/bundle");
  }
  if (checkNotFoundTesting(response)) {
    localStorage.removeItem("startTesting");
    message.error("ยังไม่มีชุดข้อสอบ");
  }
  if (
    response?.error?.code === 422 &&
    props.location.search.search("pretest") === -1
  ) {
    message.error(response?.error?.message, [5]);
  }
  localStorage.removeItem("startTesting");
  return props.history.goBack();
};
